let sessionExpiredHandled = false;

export const apiRequest = async (url, payload = {}) => {
  
  const APP_API_SECRET = process.env.REACT_APP_API_SECRET || "";  
  const storedData = window.CookieUtils.getCookie("app_data", {
    secret_level: "secure",
    secret: APP_API_SECRET,
  });
  const userData = JSON.parse(storedData);

  const finalPayload = {
    userid: userData.user_id,
    ...payload,
  };

  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(finalPayload),
  });

  let data;
  try {
    data = await res.json();
  } catch {
    data = {};
  }

  // Token expired handling (ONLY ONCE)
  if (
    res.status === 401 ||
    data?.detail === "Token validation failed. You cannot chat."
  ) {
    if (!sessionExpiredHandled) {
      sessionExpiredHandled = true;
      alert("Session Expired! Please login first");
      window.location.href = `${process.env.REACT_APP_PUBLIC_URL}/pages/login.php`;
    }
    return;
  }

  if (!res.ok) {
    throw new Error(data?.detail || "API failed");
  }

  return data;
};